import { createSelector } from 'reselect'

export const getNotificationsLoading = createSelector(
  (state) => state && state.notifications && state.notifications.list && state.notifications.list.isLoading ? state.notifications.list.isLoading : false,
  (isLoading) => isLoading
)
